import { AdditionalPartField } from '../PartsFormV3/types.d';

// Rendered when the caller supplies no additional-part-field configuration.
// `required` here is irrelevant — configured fields are always forced required
// (see ProviderPartsFormV3's configuredAdditionalPartFields).
// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_ADDITIONAL_PART_FIELDS: AdditionalPartField[] = [
  { field_name: 'serial_number', field_label: 'Serial Number', required: false },
  { field_name: 'internal_number', field_label: 'Internal Number', required: false },
  { field_name: 'rma_number', field_label: 'RMA Number', required: false },
];
